export default "__VITE_ASSET__5f368c23__"